<template>
	<div class="paymentplan card active" :class="colorClass">
		<div class="circular header">
			<h1 class="price" v-if="activeSubscription.is_free">
				{{ formatPrice(0, 2) }}
			</h1>
      <h1 v-else>
        {{ formatPrice(displayPrice, 2) }}
      </h1>
			<div class="currency bubble">{{ activeSubscription.pricing.currency }}</div>
		</div>
		<div class="interval" v-if="!activeSubscription.is_free"><h1 class="header">{{ interval }}</h1></div>
		<div v-if="finalWaterPeriodPayment && finalWaterPeriodPayment.period" class="period-price">
			{{ $t('pages.dashboard.subscriptions.final_period_price', {
				start: finalWaterPeriodPayment.period.start_date,
				end: finalWaterPeriodPayment.period.end_date
			}) }}
		</div>
		<div v-else-if="waterPeriodPrice && waterPeriodPrice.period" class="period-price">
			{{ $t('pages.dashboard.subscriptions.period_price', {
				start: waterPeriodPrice.period.start_date,
				end: waterPeriodPrice.period.end_date
			}) }}
			<span v-if="waterPeriodPrice.is_manually_adjusted">
				({{ $t('pages.dashboard.subscriptions.manually_adjusted') }})
			</span>
		</div>
		<div class="ui blue button" v-if="changeable">{{ $t('globals.buttons.change') }}</div>
	</div>
</template>

<script>
	import accounting from 'accounting'

	export default {
		name: 'ActivePaymentPlan',

		data () {
			return {
				colorClass: 'bluegreen-gradient',
				changeable: false
			}
		},

		props: [ 'activeSubscription' ],

		watch: {
			activeSubscription: function () {
			}
		},

		methods: {
			capitalizeFirst (string) {
				return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
			},

			formatPrice (amount, minfrac = 2) {
				if (amount !== null) {
					return accounting.format(amount, minfrac)
				}
			}
		},

		computed: {
			displayPrice () {
				if (this.finalWaterPeriodPayment && this.finalWaterPeriodPayment.amount !== null) {
					return this.finalWaterPeriodPayment.amount
				}

				return this.waterPeriodPrice
					? this.waterPeriodPrice.amount
					: this.activeSubscription.pricing_amount
			},

			finalWaterPeriodPayment () {
				return this.activeSubscription.final_water_period_payment || null
			},

			waterPeriodPrice () {
				return this.activeSubscription.water_period_price || null
			},

			interval () {
				let interval = ''

				if (this.activeSubscription.pricing.type === 'instant') {
					interval = this.$t('components.paymentplan.intervals.instant')
				} else if (this.activeSubscription.pricing.type === 'recurring') {
					switch (this.activeSubscription.pricing.interval) {
						case '1mo':
							interval = this.$t('components.paymentplan.intervals.monthly')
							break
						case '3mo':
							interval = this.$t('components.paymentplan.intervals.quarterly')
							break
						case '6mo':
							interval = this.$t('components.paymentplan.intervals.biannually')
							break
						case '1y':
							interval = this.$t('components.paymentplan.intervals.annually')
							break
					}
				}

				return interval
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/ActivePaymentPlan.vue